import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SpinnerComponent } from '@skylab-angular-shared/ui';

@Component({
    selector: 'skl-grid-status-cell',
    templateUrl: './grid-status-cell.component.html',
    imports: [NgClass, SpinnerComponent]
})
export class GridCellStatusComponentWC {
    @Input() public statusStyles!: string | string[];
    @Input() public statusValue!: string;
}
